module.exports = __webpack_public_path__ + "static/media/1 Sharma & Vani Organic Brief.5547e4ab.pdf";